export const TIME_SLOTS_CONTAINER_ID = 'TIME_SLOTS_CONTAINER_ID';

// datetime formats
export const EE_TIMESTAMP_FORMAT = 'yyyyMMddHHmmss.SSS';
export const DATE_FNS_SECONDS_FORMAT = 't';
export const EE_TIME_FORMAT = 'hh:mm:ss a';
export const DOWNLOADER_TIME_FORMAT = 'h:mm:ss';
export const TIMELINE_LABEL_FORMAT = 'h:mm a';
export const TIMELINE_TOOLTIP_FORMAT = 'h:mm:ss a';

// EE requests
export const PROXY_URL = 'http://localhost:8080/';
export const EE_BASE_URL = 'https://login.eagleeyenetworks.com/';
export const EE_ASSET_LIST_VIDEO_PATH = 'asset/list/video';
